import { AnyAction } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from '../../../config/constants'
import { I18nState } from './i18n.type'
import { RootState } from '../..'
import { isValidLocale } from '../../../locale'

// `fetchLanguages` a disparu : il lisait `langs/`, route qui n'existe pas, et
// personne ne le déclenchait. Les langues sont celles de `locale/`.

export const updateLanguage = (language: string): ThunkAction<Promise<string>, RootState, unknown, AnyAction> =>
	async dispatch => {
		return new Promise((resolve, reject) => {
			try {
				if (!isValidLocale(language))
					language = 'fr'

				dispatch(i18nSlice.actions.updateLanguage(language))
				resolve(language)
			} catch (error) {
				reject(error)
			}
		})
	}

const language = navigator.language.split('-')[0]
export const initialState: I18nState = {
	language: isValidLocale(language) ? language : 'fr',
	languages: [],
	status: RequestStatus.IDLE,
	error: null
}

const i18nSlice = createSlice({
	name: 'i18n',
	initialState,
	reducers: {
		updateLanguage: (state, action: PayloadAction<string>) => {
			state.language = action.payload
		}
	}
})

const { actions, reducer } = i18nSlice

export const { updateLanguage: updateLanguageAction } = actions

export default reducer
